import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center py-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sign_up_component = _resolveComponent("sign-up-component")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_sign_up_component, {
      onSignup: _ctx.onSignup,
      error: _ctx.error,
      isLoading: _ctx.isLoading
    }, null, 8, ["onSignup", "error", "isLoading"])
  ]))
}